import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const QA = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const animatePath = (path) => {
      const length = path.getTotalLength();
      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length;

      path.animate(
        [
          { strokeDashoffset: length },
          { strokeDashoffset: 0 },
        ],
        {
          duration: 2000,
          fill: 'forwards',
          easing: 'ease-in-out',
        }
      );
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const paths = entry.target.querySelectorAll('path');
          paths.forEach(animatePath);
        }
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('svg').forEach((svg) => {
      observer.observe(svg);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="bg-[#1f1f2c] w-full mx-auto min-h-[50vh] md:min-h-[60vh] p-20  flex items-center pb-28
justify-center px-4 sm:px-6 lg:px-8 relative">


      <svg
        className="absolute left-0 h-full w-[40px] sm:w-[56px] md:w-[72px] lg:w-[89px]"
        xmlns="http://www.w3.org/2000/svg"
        width="89"
        height="568"
        viewBox="0 0 89 568"
        fill="none"
      >
        <path
          d="M1 0.23938V207.654L88 285.695C88 285.695 87.5 493.945 88 567.813"
          stroke="url(#animation_gradient_left)"
          strokeWidth="2"
        />
        <path
          d="M1 0.23938V207.654L88 285.695C88 285.695 87.5 493.945 88 567.813"
          stroke="url(#paint0_linear_left)"
        />
        <defs>
          <linearGradient
            id="animation_gradient_left"
            x1="0"
            y1="0"
            x2="0"
            y2="568"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ffffff" stopOpacity="0" />
            <stop offset="0.5" stopColor="#d8c5a3" />
            <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint0_linear_left"
            x1="1"
            y1="4.50012"
            x2="1"
            y2="568"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6F6F6F" stopOpacity="0.3" />
            <stop offset="0.797799" stopColor="#6F6F6F" />
            <stop offset="1" stopColor="#6F6F6F" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>

      <div className="w-full max-w-4xl mx-auto text-center   py-12 md:py-20 lg:py-32 relative z-10">
        <div className="relative z-20 ">
   
          <h2 className="inline-block text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold bg-gradient-to-b from-[#929292] via-[#FFFFFF] to-[#857f7f] bg-clip-text text-transparent px-4 md:px-8 animate__animated animate__fadeIn animate__delay-1s"aria-label='api'>
            {t('qa1')}
          </h2>
          
          <p className="max-w-[330px] font-aventa md:max-w-3xl lg:max-w-full text-sm sm:text-base md:text-xl lg:text-2xl text-[#dcbc5c] text-center mx-auto my-4 md:my-6 lg:my-8 px-4 animate__animated animate__fadeIn animate__delay-2s word-break break-words" aria-label='uçtan uca dijital çözümler'>
            {t('qa2')}
          </p>
        </div>

        <div className="absolute inset-0 overflow-hidden mt-8 md:mt-16 lg:mt-36 z-0">
          <div className="absolute w-full h-full">
            <div
              className="absolute inset-0"
              style={{
                backgroundImage:
                  'linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)',
                backgroundSize: '120px 120px',
                opacity: 0.08,
              }}
            />
          </div>
        </div>
      </div>


      <svg
        className="absolute right-0 h-full w-[40px] sm:w-[56px] md:w-[72px] lg:w-[89px]"
        xmlns="http://www.w3.org/2000/svg"
        width="89"
        height="568"
        viewBox="0 0 89 568"
        fill="none"
      >
        <path
          d="M88 0.23938V207.654L1 285.695C1 285.695 1.5 493.945 1 567.813"
          stroke="url(#animation_gradient_right)"
          strokeWidth="2"
        />
        <path
          d="M88 0.23938V207.654L1 285.695C1 285.695 1.5 493.945 1 567.813"
          stroke="url(#paint0_linear_right)"
        />
        <defs>
          <linearGradient
            id="animation_gradient_right"
            x1="0"
            y1="0"
            x2="0"
            y2="568"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ffffff" stopOpacity="0" />
            <stop offset="0.5" stopColor="#d8c5a3" />
            <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint0_linear_right"
            x1="88"
            y1="4.50012"
            x2="88"
            y2="568"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6F6F6F" stopOpacity="0.3" />
            <stop offset="0.797799" stopColor="#6F6F6F" />
            <stop offset="1" stopColor="#6F6F6F" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default QA;
